import React from 'react'
import { Button } from '@mobi/component-library/Base/Buttons'
import { Icon } from '@mobi/component-library/Assets/Icon'
import type { FollowButtonLocation } from '../types'

export const UnfollowButtonComponent: React.FC<{
  isPending: boolean
  handleFollowClick: () => void
  location: FollowButtonLocation
}> = ({ isPending, handleFollowClick, location }) => {
  return (
    <Button
      data-testid='bet-loop-unfollow-btn'
      size='sm'
      color='secondary_outline'
      disabled={isPending}
      onClick={handleFollowClick}
    >
      {location === 'follow-list' || location === 'search-page' ? (
        <span>Unfollow</span>
      ) : (
        <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          Following <Icon name='LineCheck' size='1.5rem' />
        </span>
      )}
    </Button>
  )
}
